import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isMachineCodingEnabledFor } from '../../config/featureAccess';

const MachineCodingAccessGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { state } = useAuth();
  const location = useLocation();

  if (state.isLoading) {
    return <div className="flex min-h-[60vh] items-center justify-center text-sm text-gray-500">Checking practice access…</div>;
  }

  if (!state.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!isMachineCodingEnabledFor(state.user?.enabledFeatures)) {
    return <Navigate to="/practice" replace />;
  }

  return <>{children}</>;
};

export default MachineCodingAccessGuard;
